import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { AjaxContext, AppContext } from 'commons-ui';
import * as dashboardModel from '../../utils/model';

const useEdit = () => {
	const { postData } = useContext(AjaxContext);
	const {
		app: { appName },
		showAlert
	} = useContext(AppContext);
	const [showLoader, setShowLoader] = useState(false);
	const history = useHistory();
	const location = useLocation();

	const handleFormSubmit = async (submittedData: dashboardModel.IRewardCoinsUtil) => {
		try {
			const result: { data: dashboardModel.RESPONSE } = await postData({
				endpoint: '/marketing/dashboard/cashbackUtil/editCashbackSegments',
				queryParams: {
					appName
				},
				body: {
					segmentName: submittedData?.segmentName,
					cashbackUtil: submittedData?.cashbackUtil,
					bonusUtil: submittedData?.bonusUtil
				}
			});
			if (!result?.data?.success) throw Error('Error in updating the config!');
			return;
		} catch (error) {
			showAlert('Error in updating the config', { type: 'error' });
		} finally {
			history.goBack();
		}
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data: location?.state?.rowData,
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useEdit;
